import { NodeType } from '../../node/types';
import { DEFAULT_LOCATION as loc } from '../../source/location';

export const createNullLiteral = () => ({
  type: NodeType.NullLiteral,
  loc,
});
